export function convertToType(
  value: string,
  currentType: 'days' | 'hours',
  newType: 'days' | 'hours'
): number {
  if (value === '' || value === null || value === '0') {
    return 0;
  }

  switch (currentType) {
    case 'days':
      return newType === 'days' ? parseInt(value) : parseInt(value) * 24;
    case 'hours':
      return newType === 'hours' ? parseInt(value) : parseInt(value) / 24;
    default:
      throw new Error('Invalid type provided. Must be "days" or "hours".');
  }
}
